module.exports = __webpack_public_path__ + "static/media/protect.478a4c86.svg";